// extracted by mini-css-extract-plugin
export default {"header":"BulkAssign_header__PZkzK","body":"BulkAssign_body__ycYh5","saveButton":"BulkAssign_saveButton__Lirbl","cancelButton":"BulkAssign_cancelButton__+JM+f"};